export function coachPoolReducer(state, action) {
  switch (action.type) {
    case "loadCoachPools":
      return {
        ...state,
        coachPools: action.coachPools,
      };
    case "deleteCoachPool":
      return {
        ...state,
        coachPools: state.coachPools.filter(
          (item) => parseInt(item.id) != parseInt(action.coachPoolId)
        ),
      };
    case "showModal":
      return {
        ...state,
        showModal: true,
      };
    case "hideModal":
      return {
        ...state,
        showModal: false,
      };
    default:
      throw new Error();
  }
}
